import { IconProps, Icon } from "@chakra-ui/react";
import React from 'react';

const CloseIcon = ({ ...props }: IconProps) => {
  return (
    <Icon
      w={6}
      h={6}
      fill="gray.500"
      viewBox="0 0 24 24"
      {...props}
      stroke="none"
    >
      <path d="M18.692 6.795a1.05 1.05 0 00-1.483-1.483l-5.205 5.205-5.209-5.209a1.05 1.05 0 00-1.483 1.483l5.205 5.205-5.209 5.209a1.05 1.05 0 001.483 1.483l5.205-5.205 5.209 5.209a1.05 1.05 0 001.483-1.483l-5.205-5.205 5.209-5.209z" />
    </Icon>
  );
};

export default CloseIcon;
